import type { AcceleratorBatch, AccountRoles } from '$shared/lib';

export interface IOnboardingParams
  extends IAboutYou,
    IInterestsAndSkillsParams,
    ISourceAndReferralParams {}

export interface IUser extends IAboutYou, IUserInterestsAndSkillsParams {
  userId: string;
  username: string;
}

export interface IAboutYou {
  avatarId?: number;
  displayName: string;
  username: string;
  country: string;
  city: string;
  languages: string[];
  aboutYou: string;
  currentPosition: string;
  isUniversityStudent: boolean;
  githubHandle?: string;
  twitterHandle?: string;
  telegramHandle?: string;
  linkedInHandle?: string;
  avatarUrl?: string;
  accountRoles: AccountRoles[];
  batches: AcceleratorBatch[];
  email?: string;
  telegram?: string;
  contactOther?: string;
  profileAppendix?: string;
}

export interface IUserInterestsAndSkillsParams {
  interestedUseCases: string[];
  yourRoles?: string[];
  yourSkills?: string[];
  lookingToBuild?: string;
  rolesLookingFor?: string[];
  lookingForCollab: boolean;
}

export interface IInterestsAndSkillsParams {
  interestedUseCases: string[];
  yourRoles?: string[];
  yourSkills?: string[];
  lookingToBuild?: string;
  rolesLookingFor?: string[];
  lookingForCollab: boolean;
  onboardingSource?: string;
}

export interface ISourceAndReferralParams {
  // userId: number;
  // hackathonId: number;
  primarySource: { name?: string; other?: string };
  contributingSources?: { name: string }[];
  referralCode?: string;
  agreedToTerms: boolean;
}

export interface IAboutYouErrors {
  displayName: string[];
  username: string[];
  city: string[];
  country: string[];
  languages: string[];
  aboutYou: string[];
  currentPosition: string[];
  isUniversityStudent: string[];
  githubHandle: string[];
  twitterHandle: string[];
  telegramHandle: string[];
  linkedInHandle: string[];
}

export interface IInterestsAndSkillsParamsErrors {
  interestedUseCases: string[];
  yourRoles: string[];
  yourSkills: string[];
  lookingToBuild: string[];
  rolesLookingFor: string[];
  lookingForCollab: string[];
  onboardingSource: string[];
}

export interface ISourceAndReferralParamsErrors {
  primarySource: string[];
  contributingSources: string[];
  referralCode: string[];
  agreedToTerms: string[];
}

export interface IProfileListResponse {
  profiles: IUser[];
  hasMore: boolean;
}

export interface IProfileSearchParams {
  queryStart: string;
  nameQuery?: string;
  role?: string;
  skills?: string[];
  useCases?: string[];
  languages?: string[];
  country?: string;
  city?: string;
  lookingForCollab?: boolean;
  isUniversityStudent?: boolean;
  limit?: string;
  offset?: string;
}

export enum UsernameValidationCode {
  INAPPROPRIATE = 'INAPPROPRIATE',
  UNAVAILABLE = 'UNAVAILABLE',
  AVAILABLE = 'AVAILABLE',
}

export interface IUsernameValidationResponse {
  code: UsernameValidationCode;
  message: string;
}
